import {DialogFragment, PageFragment, PageFragmentProps} from "@/shared/PageFragment";
import {Box} from "@mui/material";
import {FormGenContainer, FormGenContainerMode} from "@/shared/FormGenContainer";
import {PAGE_FRAGMENT_LG_WIDTH} from "@/shared/dimens";
import {BaseApp, DIALOG_FLAG_DISABLE_BACKDROP_CLICK, DIALOG_FLAG_SHOW_CLOSE} from "@/shared/BaseApp";
import React from "react";
import {LabelerTask, LabelerTasks, ResourceData} from "@/fyneai-shared/types";

export class EditTaskHelper {

  static addTask(datasetId: string) {
    BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK},
      () => <EditLabelerTaskFragment datasetId={datasetId} onLabelerTaskSaved={task => BaseApp.CONTEXT.hideDialog()}/>);
  }

  static editTask(datasetId: string, task: LabelerTask) {
    BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK},
      () => <EditLabelerTaskFragment datasetId={datasetId} edit={task}
                                     onLabelerTaskSaved={task => BaseApp.CONTEXT.hideDialog()}/>);
  }

  static duplicateTask(datasetId: string, task: LabelerTask) {
    const duplicate  = task.duplicate();
    BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK},
      () => <EditLabelerTaskFragment datasetId={datasetId} edit={duplicate}
                                     onLabelerTaskSaved={task => BaseApp.CONTEXT.hideDialog()}/>);
  }

  static async deleteTask(datasetId: string, task: LabelerTask) {
    const labelerTasks = new LabelerTasks(ResourceData.projectId(), datasetId);
    await labelerTasks.deleteListItemById(task.id);
  }
}

type EditLabelerTaskFragmentProps = PageFragmentProps & {
  datasetId: string,
  edit?: LabelerTask,
  onLabelerTaskSaved: (task: LabelerTask) => void,
}

class EditLabelerTaskFragment extends DialogFragment<EditLabelerTaskFragmentProps> {

  private readonly labelerTasks = new LabelerTasks(ResourceData.projectId(), this.props.datasetId);
  private readonly labelerTask = this.props.edit ? this.props.edit : LabelerTask.createNew();

  protected onCreateState() {
    return {
      ...super.onCreateState(),
      title: this.props.edit ? "Edit task" : "Add task",
    };
  }

  protected styleFlags(): number {
    return PageFragment.STYLE_ACTION_PANEL_TYPE_BUTTON_FLAG;
  }

  protected getActionButtonText(): string {
    return this.props.edit ? "Save" : "Add";
  }

  onActionButtonClicked() {
    this.saveLabelerTask().then(() => this.props.onLabelerTaskSaved(this.labelerTask));
  }

  private async saveLabelerTask() {
    await this.labelerTasks.addListItem(this.labelerTask);
  }

  renderContent(): React.ReactElement | null {
    return <Box style={{display: "flex", width: "84dvw", maxWidth: PAGE_FRAGMENT_LG_WIDTH}}>
      <FormGenContainer
        mode={this.props.edit ? FormGenContainerMode.EDIT : FormGenContainerMode.CREATE}
        content={this.labelerTask}
        saveActionButtonProvider={this}/>
    </Box>;
  }
}
